










import { defineComponent } from '@nuxtjs/composition-api'
import NavigationLinksBlock from '@/components/Navigation/NavigationLinksBlock.vue'

export default defineComponent({
  name: 'NavigationLinks',
  components: { NavigationLinksBlock },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
})
